module.exports = __webpack_public_path__ + "bacd34d95d43c6e7e29a28330959b715.png";